<div class="cooking-story-header" [ngClass]="{ shadow: shadowNav }">
  <img
    src="assets/cookingbook/angle-white.svg"
    class="goback icon-shadow"
    (click)="goBack()"
    alt=""
  />
  <p class="title">کتاب آشپزی</p>
  <img
    class="icon heart icon-shadow center"
    src="assets/cookingbook/like-transparent.svg"
    (click)="goToFavorite()"
    alt=""
  />
</div>
<div class="cooking-story-body" (scroll)="scrolling($event)" #scroolEl>
  <div class="search-box" (click)="openSearch()">
    <img src="assets/cookingbook/search.svg" class="icon" alt="" />
    <input type="text" placeholder="جست و جوی غذای مورد نظر " />
  </div>
  <div class="categories-container">
    <div
      class="categories-selected categorie-box"
      [ngClass]="{ active: isScrolled }"
      *ngIf="isInView() && selectedCategorieId"
    >
      <img [src]="getSelectedItem().selectImage" alt="" />
      <p class="categorie-name active">
        {{ getSelectedItem().name }}
      </p>
    </div>
    <div class="notmoved" *ngIf="!isScrolled">
      <svg
        width="24"
        class="blink_me"
        height="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fill-rule="evenodd">
          <g fill="#bfbfbf">
            <path
              d="m14.954 10.74 2.877-.254c.645 0 1.169.529 1.169 1.181s-.524 1.18-1.17 1.18l-2.876-.254a.922.922 0 0 1-.918-.926c0-.512.411-.926.918-.926M5.292 10.788c.045-.046.213-.238.37-.397.921-.998 3.325-2.63 4.582-3.13.191-.08.674-.249.933-.261.247 0 .483.057.708.17.28.159.504.41.628.704.08.204.203.816.203.827.123.67.19 1.758.19 2.96 0 1.145-.067 2.189-.168 2.869-.01.012-.135.772-.27 1.032-.247.477-.73.771-1.246.771h-.045c-.337-.01-1.045-.306-1.045-.317-1.19-.5-3.537-2.052-4.48-3.085 0 0-.267-.265-.382-.43a1.375 1.375 0 0 1-.27-.828c0-.33.101-.635.292-.885"
            />
          </g>
        </g>
      </svg>
    </div>
    <div (scroll)="scrolled()" class="categories" *ngIf="selectedCategorieId">
      <div
        *ngFor="let categorie of categories; let first = first"
        class="categories-item"
        [ngClass]="{ first: first && mrScrolled }"
      >
        <div
          class="categorie-box"
          #categories
          id="{{ categorie._id }}"
          (click)="changeMenu(categorie._id)"
        >
          <img
            [src]="categorie.selectImage"
            *ngIf="categorie._id == selectedCategorieId"
            alt=""
          />
          <img
            *ngIf="categorie._id != selectedCategorieId"
            [src]="categorie.deselectImage"
            alt=""
          />
          <p
            class="categorie-name"
            [ngClass]="{ active: categorie._id == selectedCategorieId }"
          >
            {{ categorie.name }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <app-cooking-story-post
    [post]="suggestPost"
    [showTitle]="true"
    [showName]="false"
    [suggest]="true"
    [ready]="dataReady"
  ></app-cooking-story-post>

  <div class="posts" *ngIf="pagePost">
    <div *ngFor="let post of pagePost">
      <div class="pos-rel">
        <p class="post-category-title">{{ post.name }}</p>
        <p
          class="post-category-show-more"
          *ngIf="post.recipes && post.recipes.length >= 10"
          (click)="showCategory(post.type, post.name, post.type === 'kitchen')"
        >
          همه
        </p>
      </div>

      <app-cooking-story-slider
        [ready]="dataReady"
        [posts]="post"
      ></app-cooking-story-slider>
    </div>
  </div>
</div>
